import { render, staticRenderFns } from "./bandbank.vue?vue&type=template&id=76cbd81b&scoped=true&"
import script from "./bandbank.vue?vue&type=script&lang=js&"
export * from "./bandbank.vue?vue&type=script&lang=js&"
import style0 from "./bandbank.vue?vue&type=style&index=0&id=76cbd81b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76cbd81b",
  null
  
)

export default component.exports